import { Avatar, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import CustomTimePicker from "../commoncomponents/CustomTimePicker";
import {
    getAuthToken,
} from "../../utility/tokenUtility";
import { MasterGraph } from "../../utility/apiURLS";
import axios from "axios";
import CustomTextField from "../commoncomponents/CustomTextField";
import { dialogContent, validations } from "../../utility/message";
import CustomDialog from "../commoncomponents/CustomDialog";

const EditModal = ({ handleModalCancel, data, dutyOptions = [], shiftOptions = [], fetch }) => {

    const [shift, setShift] = useState("");
    const [duty, setDuty] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [shiftDate, setShiftDate] = useState("");
    const [desc, setDesc] = useState("");
    const [selectedServices, setSelectedServices] = useState([]);
    const [errorMessages, setErrorMessages] = useState({});
    const [errors, setErrors] = useState({});
    const [contentDialog, setContentDialog] = useState("")
    const [openDialog, setOpenDialog] = useState(false)
    const [openValidationDialog, setOpenValidationDialog] = useState(false)
    const [isChanged, setIsChanged] = useState(false)
    const serviceOptions = [
        { label: "FEMS", value: "FEMS", id: 1 },
        { label: "BEMS", value: "BEMS", id: 2 },
    ];

    useEffect(() => {
        setSelectedServices(data?.employee?.empService.split(", "))
        setShiftDate(data?.date)

        if (data?.day) {
            setShift(shiftOptions.find((shift) => shift.id === data?.day?.masstaffshiftId))
            setDuty(dutyOptions.find((duty) => duty.id === data?.day?.masstafavailabilityId))
            setDesc(data?.day?.shiftdesc)
            setEndTime(data?.day?.shiftendtime)
            setStartTime(data?.day?.shiftstarttime)
        }

    }, [data])


    const handleServiceChange = (event) => {
        const { value, checked } = event.target;
        setSelectedServices((prev) =>
            checked ? [...prev, value] : prev.filter((service) => service !== value)
        );
    };

    const handleAvailabilityChange = (newValue) => {
        setIsChanged(true)
        if (newValue) {
            setErrors((prev) => ({ ...prev, duty: false }));
            setErrorMessages((prev) => ({ ...prev, duty: "" }));
        }
        setDuty(newValue);
    };

    const handleShiftChange = (newValue) => {
        setIsChanged(true)
        if (newValue) {
            setErrors((prev) => ({ ...prev, shift: false }));
            setErrorMessages((prev) => ({ ...prev, shift: "" }));
        }
        setShift(newValue);
    };

    const handleStartTimeChange = (newValue) => {
        setIsChanged(true)
        if (newValue) {
            setErrors((prev) => ({ ...prev, startTime: false }));
            setErrorMessages((prev) => ({ ...prev, startTime: "" }));
        }
        setStartTime(newValue);
    };
    const handleEndTimeChange = (newValue) => {
        setIsChanged(true)
        setEndTime(newValue);
        if (newValue) {
            setErrors((prev) => ({ ...prev, endTime: false }));
            setErrorMessages((prev) => ({ ...prev, endTime: "" }));
        }
    };

    const handleDescriptionChange = (newValue) => {
        setIsChanged(true)
        if (newValue) {
            setErrors((prev) => ({ ...prev, desc: false }));
            setErrorMessages((prev) => ({ ...prev, desc: "" }));
        }
        setDesc(newValue);
    };

    const handleSubmit = () => {
        const requiredFields = [
            { field: "shift", value: shift, message: "Shift is Required" },
            { field: "duty", value: duty, message: "ON CALL/OFF DAY/STAND BY is Required" },
            { field: "startTime", value: startTime, message: "Shift Start Time is Required" },
            { field: "endTime", value: endTime, message: "Shift End Time is Required" },
            { field: "desc", value: desc, message: "Shift/Rotation Description is Required" },
        ];

        let isValid = true;

        // Check required fields
        requiredFields.forEach(({ field, value, message }) => {
            if (!value || (Array.isArray(value) && value.length === 0)) {
                isValid = false;
                setErrors(prev => ({ ...prev, [field]: true }));
                setErrorMessages(prev => ({ ...prev, [field]: message }));
            }
        });

        // If the form is valid, proceed with saving
        if (isValid) {
            // Assuming handleSave is the function to save data
            handleSave();
        }
    };

    // Helper function to format Date object as YYYY-MM-DD
    const formatDate = (date, dbFormat = true) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
        const day = String(date.getDate()).padStart(2, "0");
        return dbFormat ? `${year}-${month}-${day} ` : `${day}/${month}/${year} `;
    };

    // Helper function to parse DD/MM/YYYY to a Date object
    const parseDate = (dateStr) => {
        const [day, month, year] = dateStr.split("/").map(Number);
        return new Date(year, month - 1, day); // Month is zero-based in JavaScript
    };


    const handleSave = async () => {
        // onSave({ fromDate, shiftDate, shift, duty, startTime, endTime, desc });
        // handleModalCancel(false)();


        const start = parseDate(shiftDate);

        const formattedStartDate = formatDate(start);

        // Create a new Date object for shiftstarttime and shiftendtime, including time
        const shiftStartTime = new Date(`${formattedStartDate} ${startTime}:00`);
        const shiftEndTime = new Date(`${formattedStartDate} ${endTime}:00`);

        // If shiftEndTime is earlier than shiftStartTime, move shiftEndTime to the next day
        if (shiftEndTime <= shiftStartTime) {
            shiftEndTime.setDate(shiftEndTime.getDate() + 1);
        }

        const postData = {
            shiftstarttime: `${formattedStartDate} ${startTime}:00`,
            shiftendtime: `${formatDate(shiftEndTime)} ${endTime}:00`,
            shiftdesc: desc,
            masstaffshiftId: shift.id,
            masstaffavailabilityId: duty.id,
            employeeid: data?.employee?.masemployeedetailsId,
            id: data?.day ? data?.day?.detailsId : "",
            masstaffdutyrosterId: data?.employee?.id
        }

        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    // Attach bearer token to request header
                    Authorization: `Bearer ${token}`,
                },
            };
            const UrlDetails = `${MasterGraph}/api/masstaffdutyrosterdetails`
            const result = await axios({
                method: data?.day ? "put" : "post",
                url: UrlDetails,
                data: data?.day ? postData : [postData],
                headers: config.headers,
            });
            if (result.status === 200) {
                setContentDialog(dialogContent.updated);
                setIsChanged(false);
                setOpenValidationDialog(true);
                fetch()
            }

        } catch (error) {
            console.log(error);
            if (error.response.status === 400) {
                setContentDialog(error.response.data.detail || validations.default);
                setOpenValidationDialog(true);
            }
        }


    };

    const handleDialogClose = () => {
        if (isChanged) {
            setOpenDialog(false);
        }

    };

    const handleDialogConfirm = () => {
        setOpenValidationDialog(false);
        setOpenDialog(false);
        if (isChanged && !openValidationDialog) {
            handleModalCancel(false)()
        }
    };
    const handleCancel = () => {
        if (!isChanged) {
            handleModalCancel(false)()
        } else {
            setOpenDialog(true);
            setContentDialog(dialogContent.modified);
        }
    };

    return (
        <>
            <Stack direction={"row"} justifyContent={"space-between"} mb={1}>
                <Stack>
                    <Typography variant="title2">Edit Shift</Typography>
                </Stack>
                <IconButton onClick={handleCancel}>
                    <HighlightOffIcon />
                </IconButton>
            </Stack>

            <Stack mb={2} position={"relative"} direction={"row"}>
                <Avatar sx={{ width: 100, height: 100 }} alt="" src={data?.employee?.imagepath} />
                <Stack ml={3} mt={1}>
                    <Stack direction={"row"}>
                        <Typography
                            fontSize={16}
                            color={"text.secondary"}
                            sx={{
                                whiteSpace: "normal",
                                wordBreak: "keep-all",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {data?.employee?.employeeName}
                        </Typography>
                    </Stack>
                    <Stack flexWrap={"wrap"} mt={1}>
                        <Typography color={"primary.light"} fontWeight={500} fontSize={16}>
                            {data?.employee?.empCode}
                        </Typography>
                        {true && (
                            <Typography
                                color={"success.shade"}
                                fontWeight={500}
                                sx={{
                                    whiteSpace: "normal",
                                    wordBreak: "keep-all",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}
                                fontSize={16}
                            >
                                {data?.employee?.roleDesc}
                            </Typography>
                        )}
                    </Stack>
                </Stack>
            </Stack>
            <Stack direction={"row"} gap={2} justifyContent={"space-between"} mt={2}>
                <Box width={"21%"}>
                    <FormControl fullWidth error={true}>
                        <Box>
                            <Typography variant="labelSm">Service</Typography>
                        </Box>
                        <FormGroup row>
                            {serviceOptions.map((service) => (
                                <FormControlLabel
                                    key={service.value}
                                    control={
                                        <Checkbox
                                            error={true}
                                            checked={selectedServices?.includes(service.value)}
                                            onChange={handleServiceChange}
                                            value={service.value}
                                            disabled={true}
                                        />
                                    }
                                    label={service.label}
                                />
                            ))}
                        </FormGroup>
                    </FormControl>
                </Box>
                <Box width={"25%"}>
                    <CustomDatePicker
                        modal={true}
                        label={"Shift Date"}
                        disabled={true}
                        value={shiftDate}
                        error={errors.shiftDate}
                        helperText={errorMessages.shiftDate}
                        isMandatoryField={true}
                    />
                </Box>
                <Box width={"25%"}>
                    <CustomSelectInput
                        modal={true}
                        label={"Shift"}
                        options={shiftOptions}
                        onChange={handleShiftChange}
                        value={shift}
                        error={errors.shift}
                        helperText={errorMessages.shift}
                        isMandatoryField={true}
                    />
                </Box>
                <Box width={"25%"}>
                    <CustomSelectInput
                        modal={true}
                        label={"Options"}
                        options={dutyOptions}
                        onChange={handleAvailabilityChange}
                        value={duty}
                        error={errors.duty}
                        helperText={errorMessages.duty}
                        isMandatoryField={true}
                    />
                </Box>
            </Stack>
            <Stack direction={"row"} gap={2} justifyContent={"space-between"} mt={2}>
                <Box width={"25%"}>
                    <CustomTimePicker
                        modal={true}
                        label={"Shift Start Time"}
                        onTimeChange={handleStartTimeChange}
                        value={startTime}
                        error={errors.startTime}
                        helperText={errorMessages.startTime}
                        isMandatoryField={true}
                    />
                </Box>
                <Box width={"25%"}>
                    <CustomTimePicker
                        modal={true}
                        label={"Shift End Time"}
                        onTimeChange={handleEndTimeChange}
                        value={endTime}
                        error={errors.endTime}
                        helperText={errorMessages.endTime}
                        isMandatoryField={true}
                    />
                </Box>
                <Box width={"50%"}>
                    <CustomTextField
                        modal={true}
                        label={"Shift/Rotation Description"}
                        onChange={handleDescriptionChange}
                        value={desc}
                        error={errors.desc}
                        helperText={errorMessages.desc}
                        isMandatoryField={true}
                    />
                </Box>
            </Stack>
            <Stack direction={"row"} gap={2} justifyContent={"end"} mt={2}>
                <Button variant="contained" onClick={handleSubmit}>Update</Button>
                <Button variant="outlined" onClick={handleCancel}>Cancel</Button>
            </Stack>
            <CustomDialog
                cancelBtn={"No"}
                open={openDialog}
                onConfirm={handleDialogConfirm}
                content={contentDialog}
                onClose={handleDialogClose}
                confirmBtn={"Yes"}
            />
            <CustomDialog
                open={openValidationDialog}
                onConfirm={handleDialogConfirm}
                content={contentDialog}
                onClose={handleDialogClose}
                confirmBtn={"Ok"}
            />
        </>
    );
};

export default EditModal;
